import { UserQueueSettings } from '../../interfaces/user-queue-settings';
import { LimitOffsetPaging, Sort } from '../paged-results/limit-offset-paging.model';

export class PrescriberIncorrectInformationRequestFilters {
  status: string[] = ['needs_review'];
}

export class PrescriberIncorrectInformationRequestQueueSettings implements UserQueueSettings {
  filters: PrescriberIncorrectInformationRequestFilters;
  paging: LimitOffsetPaging = LimitOffsetPaging.empty;
  sort: Sort;
  position: number;
}
